import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  suiteList: { loading: false, data: null, error: null },
  createSuite: { loading: false, data: null, error: null },
  updateSuite: { loading: false, data: null, error: null },
  deleteSuite: { loading: false, data: null, error: null },
};

export const SuiteSlice = createSlice({
  name: "suite",
  initialState,
  reducers: {
    fetchSuiteListRequest: (state) => {
      state.suiteList.loading = true;
      state.suiteList.error = null;
    },
    fetchSuiteListSuccess: (state, action) => {
      state.suiteList.data = action.payload;
      state.suiteList.loading = false;
      state.suiteList.error = null;
    },
    fetchSuiteListFailure: (state, action) => {
      state.suiteList.data = null;
      state.suiteList.loading = false;
      state.suiteList.error = action.payload;
    },
    createSuiteRequest: (state) => {
      state.createSuite.loading = true;
      state.createSuite.error = null;
    },
    createSuiteSuccess: (state, action) => {
      state.createSuite.data = action.payload;
      state.createSuite.loading = false;
      state.createSuite.error = null;
      if (state.suiteList?.data?.data) {
        state.suiteList.data = {
          ...state.suiteList.data,
          data: [...(state.suiteList.data.data || []), action.payload],
          total: (state.suiteList.data.total || 0) + 1,
        };
      }
    },
    createSuiteFailure: (state, action) => {
      state.createSuite.data = null;
      state.createSuite.loading = false;
      state.createSuite.error = action.payload;
    },
    updateSuiteRequest: (state) => {
      state.updateSuite.loading = true;
      state.updateSuite.error = null;
    },
    updateSuiteSuccess: (state, action) => {
      state.updateSuite.data = action.payload;
      state.updateSuite.loading = false;
      state.updateSuite.error = null;
      if (state.suiteList?.data?.data) {
        state.suiteList.data = {
          ...state.suiteList.data,
          data: state.suiteList.data.data.map((s) =>
            s._id === action.payload._id ? { ...s, ...action.payload } : s
          ),
        };
      }
    },
    updateSuiteFailure: (state, action) => {
      state.updateSuite.data = null;
      state.updateSuite.loading = false;
      state.updateSuite.error = action.payload;
    },
    deleteSuiteRequest: (state) => {
      state.deleteSuite.loading = true;
      state.deleteSuite.error = null;
    },
    deleteSuiteSuccess: (state, action) => {
      state.deleteSuite.data = action.payload;
      state.deleteSuite.loading = false;
      state.deleteSuite.error = null;
      if (state.suiteList?.data?.data) {
        state.suiteList.data = {
          ...state.suiteList.data,
          data: state.suiteList.data.data.filter((s) => s._id !== action.payload._id),
          total: Math.max(0, (state.suiteList.data.total || 0) - 1),
        };
      }
    },
    deleteSuiteFailure: (state, action) => {
      state.deleteSuite.data = null;
      state.deleteSuite.loading = false;
      state.deleteSuite.error = action.payload;
    },
  },
});

export const {
  fetchSuiteListRequest,
  fetchSuiteListSuccess,
  fetchSuiteListFailure,
  createSuiteRequest,
  createSuiteSuccess,
  createSuiteFailure,
  updateSuiteRequest,
  updateSuiteSuccess,
  updateSuiteFailure,
  deleteSuiteRequest,
  deleteSuiteSuccess,
  deleteSuiteFailure,
} = SuiteSlice.actions;

export const getSuiteListState = (store) => store.suite?.suiteList;
export const getUpdateSuiteState = (store) => store.suite?.updateSuite;
export const getCreateSuiteState = (store) => store.suite?.createSuite;

export default SuiteSlice.reducer;
